import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import generatePath from '~settings/routing';
import { propertyDraftStatus } from '~constants/pending-approval';
import { ExpiredIcon as ExpiredIconIcon } from 'common/components/svgs';

export default class Reminder extends React.PureComponent {
  handleClickCheck = () => {
    const { propertySlug, category } = this.props;

    let url = '';
    if (category) {
      url = generatePath('comments', { propertySlug }, { category });
    } else {
      url = generatePath('comments', { propertySlug });
    }

    window.open(url, '_blank');
  };

  render() {
    const { t, draft, isPublished } = this.props;

    if (!draft) {
      return null;
    }

    return (
      <div
        className={classNames('pending-approval-reminder', {
          'pending-approval-reminder--pending': draft.status === propertyDraftStatus.PENDING,
          'pending-approval-reminder--rejected': draft.status === propertyDraftStatus.REJECTED,
          'pending-approval-reminder--expired': draft.status === propertyDraftStatus.EXPIRED,
        })}
      >
        <If condition={draft.status === propertyDraftStatus.PENDING}>
          <div className="pending-approval-reminder__pending-text">
            {t('cms:cms.pending_approval.pending.reminder')}
          </div>
          <div className="pending-approval-reminder__request-by">
            {t('cms:cms.pending_approval.pending.request_by', {
              userEmail: draft.createdUser.email,
              updatedAt: moment(draft.updatedAt).format('DD/MM/YYYY'),
            })}
          </div>
        </If>
        <If condition={draft.status === propertyDraftStatus.REJECTED}>
          <span className="pending-approval-reminder__reject-text">
            <span className="pending-approval-reminder__icon-wrap">
              <CloseOutlined
                className="pending-approval-reminder__rejected-icon"
                style={{ fontSize: '8px' }}
              />
            </span>
            {t(`cms:cms.pending_approval.rejected.${isPublished ? 'published.' : ''}reminder`)}
          </span>
          <Button
            type="primary"
            size="small"
            className="pending-approval-reminder__check-btn"
            onClick={this.handleClickCheck}
          >
            {t('cms:cms.pending_approval.btn.check_feedbacks')}
          </Button>
        </If>
        <If condition={draft.status === propertyDraftStatus.EXPIRED}>
          <span className="pending-approval-reminder__expired-text">
            <ExpiredIconIcon className="pending-approval-reminder__expired-icon" />
            {t('cms:cms.pending_approval.expired.reminder')}
          </span>
          <Button
            type="primary"
            size="small"
            className="pending-approval-reminder__check-btn"
            onClick={this.handleClickCheck}
          >
            {t('cms:cms.pending_approval.btn.check_explanation')}
          </Button>
        </If>
      </div>
    );
  }
}

Reminder.propTypes = {
  t: PropTypes.func.isRequired,
  draft: PropTypes.object,
  propertySlug: PropTypes.string,
  category: PropTypes.string,
  isPublished: PropTypes.bool,
};

Reminder.defaultProps = {
  t: () => {},
  draft: {},
  propertySlug: '',
  category: '',
  isPublished: false,
};
